<script setup lang="ts">
const mailing_list = `${process.env.VUE_APP_MAILING_LIST_EMAIL}`;
</script>

<template>
  <footer class="p-4 shadow-sm">
    Powered by:
    <div class="flex-column">
      <a
        class="img"
        href="https://www.mpi-cbg.de/research/researchgroups/currentgroups/agnes-toth-petroczy"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/ATPlab.png" class="col-md-2" alt="ATPlab Logo" />
      </a>
      <a
        class="img"
        href="https://mpi-cbg.de"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="@/assets/CSBD.png" class="col-md-2" alt="CSBD Logo" />
      </a>
      <a
        class="img-2"
        href="https://mpi-cbg.de"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="@/assets/MPI_CBG_Logo_horizontal_black.png"
          class="col-md-4"
          alt="MPI-CBG Logo"
        />
      </a>
    </div>

    <hr />

    <div class="d-flex flex-row justify-content-between">
      <div class="p-2">
        <a href="/imprint">Impressum</a>
        &nbsp; | &nbsp;
        <a href="/privacy-policy">Privacy Policy</a>
      </div>

      <div class="p-2">
        <span>© 2025 <a href="/">PICNIC</a>. All Rights Reserved. </span>
      </div>
      <div class="p-2">
        <a :href="'mailto:' + mailing_list">
          <font-awesome-icon size="xl" icon="fa-solid fa-envelope" />
        </a>
      </div>
    </div>

    <div class="flex-row">
      <div class="align-text-bottom">
        <span>
          This work is licensed under a
          <a
            rel="license"
            href="http://creativecommons.org/licenses/by-sa/4.0/"
            target="_blank"
            >Creative Commons Attribution-ShareAlike 4.0 International License
          </a>
          &nbsp;
          <a
            rel="license"
            href="http://creativecommons.org/licenses/by-sa/4.0/"
          >
            <img
              alt="Creative Commons License"
              style="border-width: 0; top: 0; bottom: 0; margin: auto"
              src="https://i.creativecommons.org/l/by-sa/4.0/80x15.png"
          /></a>
        </span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
footer {
  margin-top: 50px;
}

.img {
  background-color: unset !important;
  color: unset !important;
}

.img-2 {
  background-color: unset !important;
  color: unset !important;
}

.img img {
  max-width: 150px;
  width: auto;
  height: auto;
}

.img-2 img {
  max-height: 100px;
  width: auto;
  height: auto;
}

@media (min-width: 1024px) {
  .img img {
    max-width: 150px;
    width: auto;
    height: auto;
  }

  .img-2 img {
    max-height: 100px;
    width: auto;
    height: auto;
  }
}
</style>
